import { Component, afterRender, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';
import * as moment from 'moment';
import { yearByStartEnd } from '../functions/datetime';

declare var Swiper: any;
declare var $: any;
declare var jQuery: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  newsupdate: any;
  photos: any;
  PhotosCategoriesPath: any;
  videos: any;
  videoCategoriesPath: any;
  banners: any;
  BannersPath: any;
  currentDate = moment().format('YYYY-MM-DD');
  years: any = [];
  constructor(
    private homeService: HomeService,
    private routes: ActivatedRoute,
  ) {

    afterRender(() => {
      if ($(".photoGallery").length) {
        var photoGallery = new Swiper('.photoGallery .swiper-container', {
          loop: false,
          speed: 200,
          //slidesPerView:1,
          slidesPerView: "auto",
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.mediaNext',
            prevEl: '.mediaPrev',
          },
          breakpoints: {
            767: {
              slidesPerView: 1,
              spaceBetween: 0
            }
          },
        });
        $(".photoGallery .swiper-button-pause").toggle(() => {
          $(this).addClass('play');
          photoGallery.autoplay.stop();
        }, () => {
          $(this).removeClass('play');
          photoGallery.autoplay.start();
          return false;
        });
      }

      if ($(".mediaGallery").length) {
        var mediaGallery = new Swiper('.mediaGallery .swiper-container', {
          loop: false,
          speed: 800,
          //slidesPerView:1,
          slidesPerView: "auto",
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          pagination: {
            el: '.swiper-pagination',
            clickable: true,
          },
          navigation: {
            nextEl: '.mediaNext',
            prevEl: '.mediaPrev',
          },
          breakpoints: {
            767: {
              slidesPerView: 1,
              spaceBetween: 0
            }
          },
        });

        $(".mediaarrow .swiper-button-pause").toggle(() => {
          $(this).addClass('play');
          mediaGallery.autoplay.stop();
        }, () => {
          $(this).removeClass('play');
          mediaGallery.autoplay.start();
          return false;
        });
      }
    });

  }

  ngOnInit(): void {
    const currentYear = moment().format('YYYY');
    const startYear = (parseInt(currentYear) - 100);
    this.years = yearByStartEnd(startYear, currentYear);
    this.routes.params.subscribe((params: { [x: string]: any; }) => {
      const model = params['model'];

      this.homeService.getnews(model).subscribe(data => {
        this.newsupdate = data._result.map((item: any) => {
          item.view_start_date = moment(item.start_date, 'YYYY-MM-DD').format('DD/MM/YYYY');
          return item;
        });
      });
    });
    this.routes.params.subscribe((params: { [x: string]: any; }) => {
      const model = params['model'];

      this.homeService.getPhotoCategories(model).subscribe(data => {
        this.photos = data._result;
        this.PhotosCategoriesPath = data.path;
      });
    });

    this.routes.params.subscribe((params: { [x: string]: any; }) => {
      const model = params['model'];
      this.homeService.getVideoCategories(model).subscribe(data => {
        this.videos = data._result;
        this.videoCategoriesPath = data.path;
      });
    });

    this.routes.params.subscribe((params: { [x: string]: any; }) => {
      const model = params['model'];
      this.homeService.getbanners(model).subscribe(data => {
        this.banners = data._result;
        this.BannersPath = data.path;
      });
    });
  }
  // ngAfterViewInit(): void {
  //   // this.debounce(this.initializeResTab, 100)();
  //   if ($(".resTab").length) {
  //     $('.resTab').responsiveTabs({
  //       rotate: false,
  //       startCollapsed: 'tab', //accordion
  //       collapsible: 'accordion', //accordion
  //       scrollToAccordion: true,
  //       scrollToAccordionOnLoad: false
  //     });
  //   }
  // }  

}
